<template>
  <div id="publication-dashboard--invoices">
    <h3 is="sui-header">
      <i class="chart bar outline icon"></i>
      {{ $t('Invoices') }}
    </h3>
    <sui-divider />
    <div class="row">
      <sui-table celled>
        <sui-table-header>
          <sui-table-row>
            <sui-table-header-cell>{{ $t('Invoice Number') }}</sui-table-header-cell>
            <sui-table-header-cell>{{ $t('Start Date') }}</sui-table-header-cell>
            <sui-table-header-cell>{{ $t('End date') }}</sui-table-header-cell>
            <sui-table-header-cell>{{ $t('Due Date') }}</sui-table-header-cell>
            <sui-table-header-cell>{{ $t('Product') }}</sui-table-header-cell>
            <sui-table-header-cell>{{ $t('Status') }}</sui-table-header-cell>
            <sui-table-header-cell>{{ $t('Document') }}</sui-table-header-cell>
          </sui-table-row>
        </sui-table-header>
        <sui-table-body>
          <sui-table-row v-for="item in invoicesData" :key="item.id" >
            <sui-table-cell>{{ item.invoice_number }}</sui-table-cell>
            <sui-table-cell>{{ item.invoice_date }}</sui-table-cell>
            <sui-table-cell>{{ item.invoice_end_date }}</sui-table-cell>
            <sui-table-cell>{{ item.invoice_due_date }}</sui-table-cell>
            <sui-table-cell>{{ item.product }}</sui-table-cell>
            <sui-table-cell>{{ item.status }}</sui-table-cell>
            <sui-table-cell>
              <a :href="item.document" target="_blank"><i class="eye icon"></i></a>
            </sui-table-cell>
          </sui-table-row>
        </sui-table-body>
      </sui-table>
    </div>
    <sui-dimmer :active="loading" inverted>
      <sui-loader />
    </sui-dimmer>
  </div>
</template>

<script>

export default {
  name: 'invoices',
  props: ['dataRequested', 'invoicesData'],
  data() {
    return {
      loading: true
    };
  },
  updated() {
    this.removeLoader();
  },
  mounted() {
    this.removeLoader();
  },
  methods: {
    removeLoader() {
      if (this.dataRequested) {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>

</style>
